import { BaseItem } from "../../types";

export const currentItems: BaseItem[] = [
  {
    name: "OnceLegos.com",
    size: "1.2GB",
    dateAdded: "Present (WIP)",
    kind: "PROJECT",
    url: "https://oncelegos.com",
    contentUrl: "/content/oncelegos.png",
    description: "Website for high end luxury goods reseller",
  },
  {
    name: "Polymarket Trading Bot",
    size: "850MB",
    dateAdded: "Present (WIP)",
    kind: "PROJECT",
    url: "https://polymarket.com/0x9fBd6a6Eb867EffC41c01C3fb6947698A7703D15",
    description: "Automated algorithm for placing +EV sports bets",
  },
  {
    name: "joinduett.com",
    size: "1.2GB",
    dateAdded: "2025 (Paused)",
    kind: "PROJECT",
    url: "https://joinduett.com",
    contentUrl: "/content/duett.png",
    //description: "Social platform for music collaboration",
  },
  {
    name: "goatedchat.com",
    size: "1.2GB",
    dateAdded: "2025 (🪦)",
    kind: "PROJECT",
    url: "https://goatedchat.com",
    contentUrl: "/content/goatedchat.png",
    //description: "Real-time chat application with AI features",
  },
];
